import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEmail, requiredString } from '@/utils/zodUtils';

export const AddNewAdminSchema = (t: GetTextIdTranslationType) =>
  z.object({
    username: requiredEmail(t),
    password: requiredString(t),
  });

export type AddNewAdminType = z.infer<ReturnType<typeof AddNewAdminSchema>>;
